var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.organization
    ? _c(
        "div",
        { staticClass: "mb-12" },
        [
          _c("h1", { staticClass: "mt-2 mb-4 font-sans text-n-gray-dark" }, [
            _vm._v("Additional Information"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", [
              _vm._v(
                "Do you want to be represented as yourself or your organization?"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.organization.type === "individual"
                      ? "Myself"
                      : "My organization"
                  ) +
                  "\n    "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full mb-12" }, [
            _c("label", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.isIndividual ? "Public" : "Organization") +
                  " name "
              ),
              _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|min:5",
                  expression: "'required|min:5'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.name,
                  expression: "form.name",
                },
              ],
              staticClass: "w-full",
              attrs: {
                name: "name",
                type: "text",
                placeholder: "Public name displayed",
              },
              domProps: { value: _vm.form.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("name"),
                    expression: "errors.has('name')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v("\n      " + _vm._s(_vm.errors.first("name")) + "\n    ")]
            ),
          ]),
          _vm._v(" "),
          !_vm.isIndividual
            ? [
                _c("div", { staticClass: "mb-12" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.subtype,
                          expression: "form.subtype",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: { name: "organization_subtype" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "subtype",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { disabled: "" }, domProps: { value: null } },
                        [_vm._v(" -- please select -- ")]
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.options.organizationSubtypes,
                        function (subtype) {
                          return _c(
                            "option",
                            { key: subtype, domProps: { value: subtype } },
                            [
                              _vm._v(
                                "\n          " + _vm._s(subtype) + "\n        "
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("organization_subtype"),
                          expression: "errors.has('organization_subtype')",
                        },
                      ],
                      staticClass: "error text-error-red text-lg",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            (
                              _vm.errors.first("organization_subtype") || ""
                            ).replace("_", " ")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "w-full mb-12" }, [
            _c("label", [_vm._v("Website")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { url: { require_protocol: true } },
                  expression: "{ url: { require_protocol: true } }",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.website,
                  expression: "form.website",
                },
              ],
              staticClass: "w-full",
              attrs: {
                name: "website",
                type: "text",
                placeholder: "https://letsreimagine.org",
              },
              domProps: { value: _vm.form.website },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "website", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("website"),
                    expression: "errors.has('website')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.errors.first("website")) + "\n    "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", [
              _vm._v(
                "\n      What country " +
                  _vm._s(
                    _vm.isIndividual ? "are you" : "is your orgainzation"
                  ) +
                  " located in?\n      "
              ),
              _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.country,
                    expression: "form.country",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { name: "country" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "country",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c(
                  "option",
                  { attrs: { disabled: "" }, domProps: { value: null } },
                  [_vm._v(" -- please select -- ")]
                ),
                _vm._v(" "),
                _vm._l(_vm.options.countries, function (country) {
                  return _c(
                    "option",
                    { key: country.code, domProps: { value: country.code } },
                    [_vm._v("\n        " + _vm._s(country.name) + "\n      ")]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("country"),
                    expression: "errors.has('country')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.errors.first("country")) + "\n    "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-col md:flex-row mb-12" },
            [
              _c(
                "div",
                {
                  class: [
                    _vm.isFromUnitedStates ? "w-full md:w-1/2" : "w-full",
                  ],
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.city,
                        expression: "form.city",
                      },
                    ],
                    attrs: { name: "city", type: "text", placeholder: "City" },
                    domProps: { value: _vm.form.city },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "city", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("city"),
                          expression: "errors.has('city')",
                        },
                      ],
                      staticClass: "error text-error-red text-lg",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.errors.first("city")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isFromUnitedStates
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-full md:w-1/4 pl-0 md:pl-2 mt-4 md:mt-0",
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.state,
                                expression: "form.state",
                              },
                            ],
                            attrs: { name: "state" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.form,
                                  "state",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v("-- select --"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.options.states, function (state) {
                              return _c("option", { key: state.code }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(state.name) +
                                    "\n          "
                                ),
                              ])
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("state"),
                                expression: "errors.has('state')",
                              },
                            ],
                            staticClass: "error text-error-red text-lg",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.first("state")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-full md:w-1/4 pl-0 md:pl-2 mt-4 md:mt-0",
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.zip_code,
                              expression: "form.zip_code",
                            },
                          ],
                          attrs: {
                            name: "zip_code",
                            type: "text",
                            placeholder: "Zip Code",
                          },
                          domProps: { value: _vm.form.zip_code },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "zip_code",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("zip_code"),
                                expression: "errors.has('zip_code')",
                              },
                            ],
                            staticClass: "error text-error-red text-lg",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  (_vm.errors.first("zip_code") || "").replace(
                                    "_",
                                    " "
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "button", on: { click: _vm.saveAdditionalInfo } },
            [_vm._v("\n    Update\n  ")]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n        Organization type\n        "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n        City "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n          State "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n          Zip code "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }